import { Form, Formik } from 'formik';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

import {
  arraySetFieldValueJuridicalPersonPayments,
  arraySetFieldValueNaturalPersonPayments
} from '../../pages/landing/SignUp/utils/utils';
import { formTypes } from '../../store/catalogs/forms';
import { supplierBankFields } from '../../store/catalogs/forms/suppliers';
import Button from '../Buttons/Button/Button';
import LabelFieldFormik from '../Fields/LabelField/LabelFieldFormik';
import Footer from '../Footer/Footer';
import FormCard from '../Form/FormCard/FormCard';
import FormGrid from '../Form/FormGrid/FormGrid';
import NoticeCard from '../NoticeCard/NoticeCard';
import { ReactComponent as CircleAdmiration } from '../../assets/icons/CircleAdmiration.svg';

import classes from './InfoBankSupplier.module.scss';
import { documentTypesValueAbreviationList } from '../../store/catalogs/documentTypes';
import { emailSchema, stringSchema } from '../../services/schemas';
import { messageErrorForm, messageErrorFormAccountBank } from '../../store/constants/messageErrors';
import YesNoQuestion from '../modals/YesNoQuestion/YesNoQuestion';
import Context from '../../store/context';

const statusPendingDruoAccounts = ['VERIFICATION_PENDING', 'VERIFICATION_IN_PROGRESS'];
const statusDruoAccounts = ['CONNECTED', ...statusPendingDruoAccounts];

const infoShare = {
  paymentTypeOfPerson: 'typeOfPerson',
  paymentName: 'name',
  paymentBusinessName: 'businessName',
  paymentIdentificationType: 'identificationType',
  paymentIdentificationNumber: 'identificationNumber',
  paymentCountry: 'country',
  paymentEmail: 'email',
  paymentLastName: 'lastName'
};

const InfoBankSupplier = ({
  isEditForErrorAccount,
  isEditSupplier,
  onAccept,
  question,
  data,
  infoSupplier,
  isViewInfo,
  infoValidateChange
}) => {
  const valuesDemography = {
    supplierBanksIds: isEditForErrorAccount ? [] : [],
    druoBankId: isEditForErrorAccount ? infoSupplier.druoBankId : '',
    bankAccountNumber: isEditForErrorAccount ? infoSupplier.bankAccountNumber : '',
    druoBankAccountSubtype: isEditForErrorAccount ? infoSupplier.druoBankAccountSubtype : '',
    paymentTypeOfPerson: isEditForErrorAccount ? infoSupplier.paymentTypeOfPerson : '',
    paymentName: isEditForErrorAccount ? infoSupplier.paymentName : '',
    paymentLastName: isEditForErrorAccount ? infoSupplier.paymentLastName : '',
    paymentBusinessName: isEditForErrorAccount ? infoSupplier.paymentBusinessName : '',
    paymentIdentificationType: isEditForErrorAccount ? infoSupplier.paymentIdentificationType : '',
    paymentIdentificationNumber: isEditForErrorAccount ? infoSupplier.paymentIdentificationNumber : '',
    paymentEmail: isEditForErrorAccount ? infoSupplier.paymentEmail : '',
    infoUser: false,
    ...(isEditForErrorAccount && !isViewInfo ? { druoAccountId: infoSupplier.druoAccountId } : {})
  };

  const [messageError, setMessageError] = useState(null);

  const {
    modal: { showModal }
  } = useContext(Context);

  const { businessId, businesses } = useSelector(state => state.userData);
  const { demography } = businesses[businessId];

  const validationSchema = Yup.object().shape({
    druoBankId: stringSchema(messageErrorForm.select),
    bankAccountNumber: stringSchema(messageErrorFormAccountBank.bankAccountNumber),
    druoBankAccountSubtype: stringSchema(messageErrorForm.select),
    paymentTypeOfPerson: stringSchema(messageErrorForm.select),
    paymentName: stringSchema(messageErrorFormAccountBank.paymentName),
    paymentLastName: Yup.string().when('paymentTypeOfPerson', {
      is: '1',
      then: Yup.string().nullable().notRequired(),
      otherwise: Yup.string().required(messageErrorFormAccountBank.paymentLastName)
    }),
    paymentBusinessName: Yup.string().when('paymentTypeOfPerson', {
      is: '2',
      then: Yup.string().nullable().notRequired(),
      otherwise: Yup.string().required(messageErrorFormAccountBank.businessName)
    }),
    paymentIdentificationType: stringSchema(messageErrorForm.identificationTypeAndNumber),
    paymentIdentificationNumber: stringSchema(messageErrorForm.identificationTypeAndNumber),
    paymentEmail: emailSchema(messageErrorForm.email)
  });

  const fields = {
    ...(data.length > 0 && data.some(({ bankAccount: { status } }) => statusDruoAccounts.includes(status))
      ? {
          list: {
            subtitle: 'Cuentas disponibles',
            array: [
              {
                key: 'accounts',
                label:
                  'Seleccione las cuentas que desea agregar a este proveedor. (las cuentas en estado pendiente podran ser añadidas en cuanto cambien su estado a "conectado"',
                type: formTypes.checkbox,
                options: data
                  .filter(({ bankAccount }) => statusDruoAccounts.includes(bankAccount.status))
                  .map(({ supplierBankId, bankAccount: { status, bankName, subtypeLabel, bankLast4Digits, statusLabel } }) => ({
                    showCheckbox: !statusPendingDruoAccounts.includes(status),
                    key: { value: supplierBankId, label: `${bankName} - ${subtypeLabel} - ****${bankLast4Digits} - ${statusLabel}` },
                    label: `${bankName} - ${subtypeLabel} - ****${bankLast4Digits} - ${statusLabel}`
                  })),
                cols: 2
              }
            ]
          }
        }
      : {}),
    infoBank: {
      subtitle: isEditForErrorAccount
        ? 'Actualizar cuenta bancaria'
        : isEditSupplier
        ? 'Conectar nueva cuenta bancaria'
        : 'Agrega la información bancaria del proveedor',
      array: [
        supplierBankFields.infoUser,
        supplierBankFields.bankId,
        supplierBankFields.bankAccountSubtype,
        supplierBankFields.bankAccountNumber,
        supplierBankFields.typeOfPerson,
        supplierBankFields.name,
        supplierBankFields.lastName,
        supplierBankFields.businessName,
        /* supplierBankFields.identificationType, */
        supplierBankFields.identificationNumber,
        supplierBankFields.email
      ].filter((field, idx) => !isEditForErrorAccount || isViewInfo || idx !== 0)
    }
  };

  const [fieldsState, setFieldsState] = useState(fields);

  const selectedNaturalPerson = ({ entity, numberIdentification, name, email }, setFieldValue, arraySetFieldValue) => {
    arraySetFieldValue.forEach(({ key, value }) => {
      setFieldValue(key, value);
    });
    setFieldsState(fieldsValues => {
      const newArrays = [...fieldsValues[entity].array];
      /* newArrays[identificationType] = {
        ...newArrays[identificationType],
        options: newArrays[identificationType].options.filter(option => ['13', '21', '11', '22'].includes(option.value))
      }; */
      newArrays[numberIdentification] = {
        ...newArrays[numberIdentification],
        disabledType: false,
        optionsType: documentTypesValueAbreviationList.filter(option => ['13', '21', '11', '22'].includes(option.value))
      };
      newArrays[name] = {
        ...newArrays[name],
        label: 'Nombre'
      };
      newArrays[email] = {
        ...newArrays[email],
        label: 'Correo de la persona'
      };
      return { ...fieldsValues, [entity]: { ...fieldsValues[entity], array: [...newArrays] } };
    });
  };

  const selectedJuridicalPerson = ({ entity, numberIdentification, name, email }, setFieldValue, arraySetFieldValue) => {
    arraySetFieldValue.forEach(({ key, value }) => {
      setFieldValue(key, value);
    });
    setFieldsState(fieldsValues => {
      const newArrays = [...fieldsValues[entity].array];
      newArrays[numberIdentification] = {
        ...newArrays[numberIdentification],
        disabledType: true,
        optionsType: documentTypesValueAbreviationList.filter(option => ['31'].includes(option.value))
      };
      newArrays[name] = {
        ...newArrays[name],
        label: 'Nombre comercial'
      };
      newArrays[email] = {
        ...newArrays[email],
        label: 'Correo electrónico'
      };
      return { ...fieldsValues, [entity]: { ...fieldsValues[entity], array: [...newArrays] } };
    });
  };

  const keyForChangeValue = {
    infoUser: (setFieldValue, value) => {
      //if mark Si in the info bank
      if (value.length === 1) {
        if (infoSupplier.paymentTypeOfPerson === '2') {
          selectedNaturalPerson(
            { entity: 'infoBank', numberIdentification: 8, name: 5, email: 9 },
            setFieldValue,
            arraySetFieldValueNaturalPersonPayments
          );
        } else {
          selectedJuridicalPerson(
            { entity: 'infoBank', numberIdentification: 8, name: 5, email: 9 },
            setFieldValue,
            arraySetFieldValueJuridicalPersonPayments
          );
        }
        /*   setFieldsState(fieldsValues => {
          const newArrays = fieldsValues.infoBank.array.map(field => {
            if (!['druoBankId', 'bankAccountNumber', 'druoBankAccountSubtype'].includes(field.key)) {
              return { ...field, disabled: true, ...(field.key === 'paymentIdentificationNumber' ? { disabledType: true } : {}) };
            } else {
              return { ...field };
            }
          });
          return { ...fieldsValues, infoBank: { ...fieldsValues.infoBank, array: [...newArrays] } };
        }); */

        for (const field of fieldsState.infoBank.array
          .concat({ key: 'paymentIdentificationType' })
          .filter(({ key }) => !['druoBankId', 'infoUser', 'bankAccountNumber', 'druoBankAccountSubtype'].includes(key))) {
          setFieldValue(field.key, infoValidateChange[field.key]);
        }
      }
      //if not mark info bank
      else {
        /* setFieldsState(fieldsValues => {
          const newArrays = fieldsValues.infoBank.array.map(field => {
            return { ...field, disabled: false, ...(field.key === 'paymentIdentificationNumber' ? { disabledType: false } : {}) };
          });

          return { ...fieldsValues, infoBank: { ...fieldsValues.infoBank, array: [...newArrays] } };
        }); */

        for (const field of fieldsState.infoBank.array.filter(
          ({ key }) => !['druoBankId', 'infoUser', 'bankAccountNumber', 'druoBankAccountSubtype'].includes(key)
        )) {
          setFieldValue(field.key, '');
        }
      }
      setFieldValue('infoUser', value.length === 1 ? true : false);
    },
    paymentTypeOfPerson: (setFieldValue, value) => {
      const position = !isEditForErrorAccount ? 0 : -1;
      setFieldValue('paymentTypeOfPerson', value);
      if (value === '2') {
        selectedNaturalPerson(
          {
            entity: 'infoBank',

            numberIdentification: 8 + position,
            name: 5 + position,
            email: 9 + position
          },
          setFieldValue,
          arraySetFieldValueNaturalPersonPayments
        );

        return;
      } else {
        selectedJuridicalPerson(
          { entity: 'infoBank', numberIdentification: 8 + position, name: 5 + position, email: 9 + position },
          setFieldValue,
          arraySetFieldValueJuridicalPersonPayments
        );
      }
    },
    accounts: (setFieldValue, value) => {
      setFieldValue('supplierBanksIds', value);
    },
    druoBankId: (setFieldValue, { value, moviiBankId, meloBankId }) => {
      setFieldValue('druoBankId', value);
      setFieldValue('moviiBankId', moviiBankId);
      setFieldValue('meloBankId', meloBankId);
    }
  };

  const setFields = (setFieldValue, key, value) => {
    keyForChangeValue[key] ? keyForChangeValue[key](setFieldValue, value) : setFieldValue(key, value);
  };

  const validate = values => {
    const countOfFieldWithValues = fieldsState.infoBank.array.concat({ key: 'paymentIdentificationType' }).reduce((prev, { key }) => {
      if (!!values[key]) {
        return prev + 1;
      }
      return prev;
    }, 0);
    const isSupplierBanksIds = values.supplierBanksIds.length === 0;

    if (countOfFieldWithValues === 0 && isSupplierBanksIds) return setMessageError('El formulario se encuentra vacio');

    if (values.paymentTypeOfPerson === 1) {
      if (0 < countOfFieldWithValues && countOfFieldWithValues < 8)
        return setMessageError('Error en la información. Valida los datos ingresados en cada uno de los campos.');
    } else {
      if (0 < countOfFieldWithValues && countOfFieldWithValues < 9)
        return setMessageError('Error en la información. Valida los datos ingresados en cada uno de los campos.');
    }

    const isExists = data.some(
      ({ bankAccount: { bankAccountType, bankLast4Digits, bankId } }) =>
        bankAccountType === values.druoBankAccountSubtype.toLowerCase() &&
        bankLast4Digits === values.bankAccountNumber.toString().substr(-4) &&
        bankId === values.druoBankId
    );

    if (isExists) {
      setMessageError('La cuenta de banco que diligenció en el formulario ya se encuentra registrada');
      return;
    }
    if (isViewInfo) {
      //infoShare

      if (values.infoUser) {
        if (!Object.keys(infoShare).every(key => values[key] === infoValidateChange[key])) {
          showModal(
            <YesNoQuestion
              className={classes.answer}
              Icon={CircleAdmiration}
              question={question}
              subtitle='Si realizas este cambio, la información se guardará permanentemente. Sin embargo, puedes volver a realizar el cambio en cualquier momento.'
              textButton='Continuar'
              acceptHandler={() => onAccept(values)}
              backHandler={() =>
                showModal(
                  <InfoBankSupplier
                    onAccept={onAccept}
                    data={[]}
                    infoValidateChange={infoValidateChange}
                    infoSupplier={values}
                    isEditForErrorAccount={true}
                    isViewInfo={true}
                  />
                )
              }
            />
          );
        } else {
          onAccept(values);
        }
      } else {
        onAccept(values);
      }
    } else {
      onAccept(values);
    }
    //onAccept(values);
  };

  return (
    <>
      <Formik initialValues={valuesDemography} validationSchema={validationSchema} onSubmit={validate}>
        {({ setFieldValue, isSubmitting }) => (
          <Form id='infoBankForm' className={`${isEditSupplier ? classes.modal : ''} ${classes.form}`}>
            {Object.keys(fieldsState).map(field => (
              <FormCard key={field} className={classes.card} subtitle={fieldsState[field].subtitle}>
                <FormGrid
                  description={
                    (!isEditForErrorAccount || isViewInfo) && (
                      <NoticeCard
                        className={classes.notice}
                        text={`Conectar una nueva cuenta bancaria se puede demorar hasta un día hábil. Se te notificará al correo (${demography.email}) cualquier novedad (en proceso, exitosa o fallida) de una nueva conexión bancaria. `}
                      />
                    )
                  }
                  subtitle={fieldsState[field].subtitle}
                  onChange={(key, value) => setFields(setFieldValue, key, value)}
                  fields={fieldsState[field].array}
                  Render={LabelFieldFormik}
                />
              </FormCard>
            ))}
            <span className={classes['message-error']}>{messageError}</span>
            {isEditSupplier || isEditForErrorAccount || isViewInfo ? (
              <div className={classes['accept-edit']}>
                <Button custom='primary' color='purple' type='submit' disabled={isSubmitting}>
                  {isEditForErrorAccount || !isViewInfo ? 'Actualizar cuenta' : isEditSupplier ? 'Conectar cuenta' : 'Continuar'}
                </Button>
              </div>
            ) : (
              <Footer>
                <div className={classes.accept}>
                  <Button
                    name='buttonInfoBankSupplier'
                    form='infoBankForm'
                    className={classes.button}
                    custom='primary'
                    color='purple'
                    type='submit'
                    disabled={isSubmitting}>
                    {isEditSupplier ? 'Conectar cuenta' : 'Continuar'}
                  </Button>
                </div>
              </Footer>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default InfoBankSupplier;
